<template>
  <div class="container">
    <van-cell class="header">
      <div class="poi-name">
        {{ poiName }}
      </div>
      <div class="total-gtv">
        GTV：{{ totalGtv }}元
      </div>
    </van-cell>
    <template v-if="dayList && dayList.length>0">
      <van-cell>
        <div class="row">
          <span class="item">日期</span>
          <span class="item">GTV</span>
          <span class="item">操作</span>
        </div>
      </van-cell>
      <div class="group">
        <van-cell
          v-for="item in dayList"
          :key="item.day"
        >
          <div
            class="row"
            @click="onClickItem(item)"
          >
            <span class="item">{{ item.day|formatTime }}</span>
            <span class="item">{{ item.divideGtv }}元</span>
            <span class="item btn">
              查看
            </span>
          </div>
        </van-cell>
      </div>
    </template>
    <no-data
      v-else
      tips="暂无数据"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import ActivityApi from '@/api/activity';
import STATUS from '@/constants/status';
import NoData from '@/components/NoData';


export default {
  name: 'PoiMonthBillDetail',
  components: {
    NoData,
  },
  filters: {
    formatTime(value) {
      if (value) {
        return dayjs(`${value}`).format('YYYY-MM-DD');
      }
      return '-';
    },
  },
  data() {
    const { poiName } = this.$route.query;
    return {
      totalGtv: '-',
      poiName,
      dayList: [],
    };
  },
  created() {
    const {
      customerId, activityId, billMonth, poiId,
    } = this.$route.query;
    this.getActivityDayGTVList(customerId, activityId, billMonth, poiId);
  },
  methods: {
    async getActivityDayGTVList(customerId, activityId, billMonth, poiId) {
      try {
        this.$dialog.loading.show();
        const { code, data } = await ActivityApi.getActivityDayGTVList(customerId, activityId, billMonth, poiId);
        if (code === STATUS.SUCCESS) {
          this.totalGtv = data.totalGtv || 0;
          this.dayList = data.dayList || [];
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.$dialog.loading.hide();
      }
    },
    onClickItem({ day, divideGtv }) {
      const {
        customerId, activityId, poiId, billMonth,
      } = this.$route.query;
      const query = {
        customerId,
        activityId,
        poiId,
        billMonth,
        day,
        gtv: divideGtv,
      };
      this.$router.push({
        name: 'ActivityDayBillDetail',
        query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .header {
    border-bottom: 0.02rem solid #969799;
    .poi-name{
      font-weight: bold;
      font-size: 0.35rem;
      text-align: left;
    }
    .total-gtv {
      text-align: right;
    }
  }
  .group{
    height: calc(100vh - 2.26rem);
    overflow-y: auto;
  }
  .row {
    display: flex;
    background-color: white;
    .item {
      text-align: center;
      flex: 1;
      &.btn{
        color: blue;
      }
    }
  }
</style>
